// extracted by mini-css-extract-plugin
export default {"CheckboxHelp":"xr_a bhp_st bhp_sa bhp_sy bhp_sz bhp_vv bhp_ju","CheckboxHelp__paragraph":"xr_b bhp_xg","CheckboxHelp__youtube":"xr_c"};